// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-name{font-weight:bold}.tournament-label{font-size:larger;font-weight:bold}", ""]);
// Exports
module.exports = exports;
